export enum SuggesterType {
  Multiple = 'multiple',
  Single = 'single'
}
